import "../scss/yetee.scss";

import { html, render } from "lit-html";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
//import "liquid-ajax-cart";

gsap.registerPlugin(ScrollTrigger);

/* ======================================================================================= */
/* ================================================================================ GLOBAL */
/* ======================================================================================= */

/* -------------------------------------------------------- NAV */

const mainNav = document.querySelector(".nav-main");

/* -------------------------------------------------------- TIMERS */

const timer_func = {
  ms: function (now, end) {
    return end - now;
  },
  percent: function (now, start, end) {
    let dd = end - now,
      dp = dd / (end - start);

    if (now < end) {
      return Math.round(dp * 100 * 100) / 100;
    } else {
      return 0;
    }
  },
  countdown: function (now, start, end) {
    var dd = end - now,
      dhour = Math.floor((dd / (60 * 60 * 1000)) * 1),
      dmin = Math.floor(
        (((dd % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000)) * 1,
      ),
      dsec = Math.floor(
        ((((dd % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) /
          1000) *
          1,
      );

    if (now < end) {
      return (
        dhour +
        ":" +
        (dmin >= 10 ? dmin : "0" + dmin) +
        ":" +
        (dsec >= 10 ? dsec : "0" + dsec)
      );
    } else {
      return "00:00:00";
    }
  },
};

let timers = document.querySelectorAll(".js--timer");

timers.forEach((timer) => {
  // Time
  let start = Date.parse(timer.dataset.start),
    end = Date.parse(timer.dataset.end);

  // Elements
  let timerCountdown = timer.querySelector(".js--timer-countdown"),
    timerProgress = timer.querySelector(".js--timer-progress");

  const run_timer = () => {
    let now = Date.parse(new Date());

    // Sets width of color bar
    timerProgress.style.width = `${timer_func.percent(now, start, end)}%`;

    // Update color
    if (timer_func.percent(now, start, end) <= 25) {
      timerProgress.classList.add("is--red");
      timerProgress.classList.remove("is--yellow");
    } else if (
      timer_func.percent(now, start, end) > 25 &&
      timer_func.percent(now, start, end) <= 50
    ) {
      timerProgress.classList.add("is--yellow");
      timerProgress.classList.remove("is--green");
    } else {
      timerProgress.classList.add("is--green");
    }

    // Countdown
    timerCountdown.innerHTML = `${timer_func.countdown(now, start, end)}`;
  };

  run_timer();
  setInterval(run_timer, 1000);
});

/* ======================================================================================= */
/* ============================================================================== HOMEPAGE */
/* ======================================================================================= */

/* -------------------------------------------------------- FEATURE SLIDER */

let featureSliders = document.querySelectorAll(".js--feature-slider");

featureSliders.forEach((slider) => {
  const slider_feat = new Swiper(slider, {
    modules: [Navigation, Autoplay],
    initialSlide: 0,
    loop: true,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});

/* -------------------------------------------------------- PRODUCT SLIDER */

let productSliders = document.querySelectorAll(".js--product-slider");

productSliders.forEach((slider) => {
  const slider_prod = new Swiper(slider, {
    modules: [Navigation, Autoplay],
    initialSlide: 0,
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      720: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      960: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
});

/* -------------------------------------------------------- COLLECTION SLIDER */

let collectionSliders = document.querySelectorAll(".js--collection-slider");

collectionSliders.forEach((slider) => {
  const slider_prod = new Swiper(slider, {
    modules: [Autoplay],
    initialSlide: 0,
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: false,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
  });
});

/* ======================================================================================= */
/* ======================================================================== FEATURED ITEMS */
/* ======================================================================================= */

/* -------------------------------------------------------- FEATURED PRODUCT SLIDERS */

let featureImageSliders = document.querySelectorAll(
  ".js--feature-image-slider",
);

featureImageSliders.forEach((slider) => {
  const slider_feat = new Swiper(slider, {
    modules: [Autoplay],
    initialSlide: 0,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
  });
});

/* -------------------------------------------------------- FEATURED PRODUCT FORMS */

let featureForms = document.querySelectorAll(".js--feat-product-toggle");

function formBtnClick(e) {
  e.preventDefault();

  let button = e.currentTarget,
    formId = button.dataset.form,
    form = document.querySelector(`#${formId}`);

  const openText = `<span>Get it now!</span>`,
    closeText = `<span>Never mind...</span>`;

  if (!form.classList.contains("is--visible")) {
    button.innerHTML = closeText;
    gsap.to(form, {
      height: "auto",
      opacity: 1,
      scale: 1,
      margin: "1.5rem 0",
      duration: 0.5,
      ease: "power2.out",
    });
    button.classList.add("is--active");
    form.classList.add("is--visible");
  } else {
    button.innerHTML = openText;
    gsap.to(form, {
      height: 0,
      opacity: 0,
      scale: 0.9,
      margin: "0",
      duration: 0.5,
      ease: "power2.out",
    });
    button.classList.remove("is--active");
    form.classList.remove("is--visible");
  }
}

const feature_forms_actions = () => {
  featureForms.forEach((formBtn) => {
    let mq = window.matchMedia("(width >= 1200px)");

    if (mq.matches) {
      formBtn.addEventListener("click", formBtnClick);
    } else {
      formBtn.removeEventListener("click", formBtnClick);
    }
  });
};

feature_forms_actions();

/* ======================================================================================= */
/* ================================================================================ EVENTS */
/* ======================================================================================= */

/* -------------------------------------------------------- PRODUCT SLIDER */

let eventProductSliders = document.querySelectorAll(
  ".js--event-products-slider",
);

eventProductSliders.forEach((slider) => {
  const slider_prod = new Swiper(slider, {
    modules: [Autoplay],
    initialSlide: 0,
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: false,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
  });
});

/* ======================================================================================= */
/* ========================================================================== PRODUCT PAGE */
/* ======================================================================================= */

/* -------------------------------------------------------- PRODUCT FORM */

let productForms = document.querySelectorAll(".js--product-form");

// Click function for variants
const click_variant = (e, variant, el_display, el_id, el_button, el_price) => {
  e.preventDefault();

  const selected = document.querySelector(".is--selected-variant"),
    el_displayInfo = el_display.querySelector("product-form-selected-info"),
    el_displayValue = el_display.querySelector("product-form-selected-value");

  if (selected !== null) {
    selected.classList.remove("is--selected-variant");
  }

  if (!el_display.classList.contains("has--selection")) {
    el_display.classList.add("has--selection");
  }

  e.target.classList.add("is--selected-variant");
  el_displayValue.innerHTML = variant.title;
  el_id.value = variant.id;
  el_button.disabled = false;

  const price = (variant.price / 100).toFixed(2);
  const price_html = html`Price: <span> $${price} </span>`;

  render(price_html, el_price);
};

// Click function for size charts
const click_size_chart = (e, el_chart) => {
  e.preventDefault();

  el_chart.classList.add("is--active");
};

// Check for thumbnail and resize
const getThumb = (image) => {
  // Is there an image?
  if (image != null) {
    // Does the image have a src?
    if (image.src != undefined) {
      // Product or Files url?
      if (image.src.indexOf("files/") > -1) {
        let thumb_url_parts = image.src
            .replace("files/", "")
            .split("/cdn/shop/"),
          thumb_root = thumb_url_parts[0],
          thumb_id = thumb_url_parts[1].split("."),
          thumb = `${thumb_root}/cdn/shop/files/${thumb_id[0]}_300x.${thumb_id[1]}`;

        return thumb;
      } else if (image.src.indexOf("products/") > -1) {
        let thumb_url_parts = image.src
            .replace("products/", "")
            .split("/cdn/shop/"),
          thumb_root = thumb_url_parts[0],
          thumb_id = thumb_url_parts[1].split("."),
          thumb = `${thumb_root}/cdn/shop/products/${thumb_id[0]}_300x.${thumb_id[1]}`;

        return thumb;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
};

// Test for showing thumbnail
const showThumb = (image) => {
  if (image.src != null) {
    return html`<img src="${image.src}" alt="${image.alt}" />`;
  } else {
    return html``;
  }
};

// Build the options
const buildOptions = (
  data,
  el_container,
  el_display,
  el_variantId,
  el_button,
  el_price,
) => {
  // Global
  let indexStyle = -1,
    indexSize = -1,
    variants = data.variants;

  // Get Size and Style indexes
  data.options.forEach((option, index) => {
    if (option.includes("Style")) {
      indexStyle = index;
    } else if (option.includes("Size")) {
      indexSize = index;
    }
  });

  // ================================================ Apparel Form
  if (variants.length > 1 && indexStyle > -1 && data.options.length > 1) {
    let styles = [],
      images = [];

    // Construct into style format and prep variant images
    variants.forEach((variant) => {
      const thisStyle = styles.find(
        (style) => style.type === variant.options[indexStyle],
      );

      if (thisStyle) {
        thisStyle.variants.push(variant);
      } else {
        const thumbalt =
          variant.featured_image != null ? variant.featured_image.alt : null;

        styles.push({ type: variant.options[indexStyle], variants: [variant] });
        images.push({
          type: variant.options[indexStyle],
          src: getThumb(variant.featured_image),
          alt: thumbalt,
        });
      }
    });

    const checkAvailabilityGarment = (variant) => {
      if (variant.available) {
        return html`<a
          href="#"
          data-variant="${variant.id}"
          @click=${(e) =>
            click_variant(
              e,
              variant,
              el_display,
              el_variantId,
              el_button,
              el_price,
            )}
        >
          ${variant.options[indexSize]}
        </a>`;
      } else {
        return html`<span>${variant.options[indexSize]}</span>`;
      }
    };

    const showSizeChart = (style) => {
      if (findSizeChart(style) != false) {
        return html`<a
          class="js--size-chart"
          href="#"
          @click=${(e) => click_size_chart(e, findSizeChart(style))}
        >
          <span>Size Chart</span>
        </a>`;
      } else {
        return html``;
      }
    };

    const findSizeChart = (style) => {
      if (style.type == `Unisex/Men's` || style.type == `Unisex`) {
        // UNISEX
        let unisex = document.querySelector(".size-chart--unisex");
        if (unisex != null) {
          return unisex;
        } else {
          return false;
        }
      } else if (style.type == `Women's/Junior` || style.type == `Ladies'`) {
        // LADIES
        let ladies = document.querySelector(".size-chart--ladies");
        if (ladies != null) {
          return ladies;
        } else {
          return false;
        }
      } else if (style.type == `Comfort Colors`) {
        // COMFORT COLORS
        let comfort = document.querySelector(".size-chart--comfort-colors");
        if (comfort != null) {
          return comfort;
        } else {
          return false;
        }
      } else if (style.type == `Longsleeve`) {
        // LONGSLEEVE
        let longsleeve = document.querySelector(".size-chart--longsleeve");
        if (longsleeve != null) {
          return longsleeve;
        } else {
          return false;
        }
      } else if (style.type == `Zip-Up`) {
        // ZIP-UP
        let zipup = document.querySelector(".size-chart--zip-up");
        if (zipup != null) {
          return zipup;
        } else {
          return false;
        }
      } else if (style.type == `Sweatshirt`) {
        // SWEATSHIRT
        let sweatshirt = document.querySelector(".size-chart--sweatshirt");
        if (sweatshirt != null) {
          return sweatshirt;
        } else {
          return false;
        }
      } else if (style.type == `Tank Top`) {
        // TANK TOP
        let tank = document.querySelector(".size-chart--tank-top");
        if (tank != null) {
          return tank;
        } else {
          return false;
        }
      } else if (style.type == `Tie Dye`) {
        // TIE DYE
        let tiedye = document.querySelector(".size-chart--tie-dye");
        if (tiedye != null) {
          return tiedye;
        } else {
          return false;
        }
      } else if (style.type == `Varsity Jacket`) {
        // TIE DYE
        let tiedye = document.querySelector(".size-chart--varsity-jacket");
        if (tiedye != null) {
          return tiedye;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    const findIcon = (style) => {
      if (style.type == `Unisex/Men's` || style.type == `Unisex`) {
        // UNISEX
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <polygon
            points="18.5 23.5 5.5 23.5 5.5 7.5 1.5 10 1.5 3 6 0.5 18 0.5 22.5 3 22.5 10 18.5 7.5 18.5 23.5"
          />
          <path d="M15.5.5s0,4.38-3.5,4.38S8.5.5,8.5.5" />
        </svg>`;
      } else if (style.type == `Women's/Junior` || style.type == `Ladies'`) {
        // LADIES
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <polygon
            points="18.5 23.5 5.5 23.5 6.5 15 5.5 7.5 1.5 8.5 1.5 3.5 7 0.5 17 0.5 22.5 3.5 22.5 8.5 18.5 7.5 17.5 14.88 18.5 23.5"
          />
          <path d="M15.5.5s0,4.38-3.5,4.38S8.5.5,8.5.5" />
        </svg>`;
      } else if (style.type == `Comfort Colors`) {
        // COMFORT COLORS
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <polygon
            points="18.5 23.5 5.5 23.5 5.5 7.5 1.5 10 1.5 3 6 0.5 18 0.5 22.5 3 22.5 10 18.5 7.5 18.5 23.5"
          />
          <path d="M15.5.5s0,4.38-3.5,4.38S8.5.5,8.5.5" />
        </svg>`;
      } else if (style.type == `Longsleeve`) {
        // LONGSLEEVE
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <path
            d="M18.5,8V22.55H5.5V8l-2,9.5H.5L2.5,4,9,1.5s1.12,3,3,3,3-3,3-3L21.5,4l2,13.5h-3Z"
          />
        </svg>`;
      } else if (style.type == `Zip-Up`) {
        // ZIP-UP
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <polyline
            points="17.63 2.51 21.5 4 23.5 17.5 20.5 17.5 18.5 8 18.5 20.5 5.5 20.5 5.5 8 3.5 17.5 0.5 17.5 2.5 4 6.37 2.51"
          />
          <polyline points="5.5 20.5 6.5 22.5 17.5 22.5 18.5 20.5" />
          <polyline points="12 4.5 14.63 2.51 9.37 2.51 12 4.5 12 22.5" />
          <polyline
            points="13.94 5.38 17.63 2.51 15.79 0.5 8.21 0.5 6.37 2.51 10.06 5.38"
          />
        </svg>`;
      } else if (style.type == `Sweatshirt`) {
        // SWEATSHIRT
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <path
            d="M18.5,8V20.5H5.5V8l-2,9.5H.5L2.5,4,9,1.5s1.12,3,3,3,3-3,3-3L21.5,4l2,13.5h-3Z"
          />
          <polyline points="5.5 20.5 6.5 22.5 17.5 22.5 18.5 20.5" />
          <rect x="0.5" y="17.5" width="3" height="1.63" />
          <rect x="20.5" y="17.5" width="3" height="1.63" />
        </svg>`;
      } else if (style.type == `Tank Top`) {
        // TANK TOP
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <path
            d="M18.5,12V1.5l-2-1L15.5,5s-1.42,4.5-4,4.5S7.5,5,7.5,5L6.5.5l-2,1V12l-.36,4.1L3.5,23.5h16l-.65-7.42Z"
          />
        </svg>`;
      } else if (style.type == `Tie Dye`) {
        // TIE DYE
        return html`<svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enable-background="new 0 0 24 24"
          width="24px"
          height="24px"
          xml:space="preserve"
        >
          <polygon
            points="18.5 23.5 5.5 23.5 5.5 7.5 1.5 10 1.5 3 6 0.5 18 0.5 22.5 3 22.5 10 18.5 7.5 18.5 23.5"
          />
          <path d="M15.5.5s0,4.38-3.5,4.38S8.5.5,8.5.5" />
          <path
            d="M5.5,18.53a8.14,8.14,0,0,0,4.94,1.66A6.53,6.53,0,0,0,17,13.66a5.23,5.23,0,0,0-5.22-5.23,4.19,4.19,0,0,0-4.18,4.19A3.34,3.34,0,0,0,10.91,16a2.68,2.68,0,0,0,2.68-2.68,2.14,2.14,0,0,0-2.14-2.14,1.72,1.72,0,0,0-1.72,1.72,1.38,1.38,0,0,0,1.37,1.37"
          />
          <path d="M9.14,2.38a10.24,10.24,0,0,0-6.49,6.9" />
          <path d="M22.5,6.68a12.77,12.77,0,0,0-7.07-4.52" />
        </svg>`;
      } else {
        return html``;
      }
    };

    const options = html`${styles.map(
      (style, i) =>
        html`<product-form-options>
          <product-form-option-header>${style.type}</product-form-option-header>
          <figure>
            ${findIcon(style)} ${showThumb(images[i])} ${showSizeChart(style)}
          </figure>
          <variant-options>
            ${style.variants.map(
              (variant) =>
                html`<variant-option>
                  ${checkAvailabilityGarment(variant)}
                </variant-option>`,
            )}
          </variant-options>
        </product-form-options>`,
    )}`;

    render(options, el_container);
  }
  // ================================================ Basic Variant Form
  else if (
    variants.length > 1 &&
    indexStyle == -1 &&
    data.options.length == 1
  ) {
    const checkAvailability = (variant) => {
      if (variant.available) {
        return html`<a
          href="#"
          data-variant="${variant.id}"
          @click=${(e) =>
            click_variant(
              e,
              variant,
              el_display,
              el_variantId,
              el_button,
              el_price,
            )}
        >
          ${variant.title}
        </a>`;
      } else {
        return html`<span>${variant.title}</span>`;
      }
    };

    const options = html`<product-form-options>
      <product-form-option-header
        >${data.options[0]}</product-form-option-header
      >
      <variant-options class="is--basic">
        ${variants.map(
          (variant) =>
            html`<variant-option>
              ${checkAvailability(variant)}
            </variant-option>`,
        )}
      </variant-options>
    </product-form-options>`;

    render(options, el_container);
  }
  // ================================================ Single Variant Form
  else {
    el_button.disabled = false;
  }

  let price;

  if (data.price_max > data.price_min) {
    price = html`Price:
      <span>
        $${(data.price_min / 100).toFixed(2)} -
        $${(data.price_max / 100).toFixed(2)}
      </span>`;
  } else {
    if (data.compare_at_price) {
      price = html`Price:
        <span>
          $${(data.price / 100).toFixed(2)}
          <s>$${(data.compare_at_price / 100).toFixed(2)}</s></span
        >`;
    } else {
      price = html`Price: <span> $${(data.price / 100).toFixed(2)} </span>`;
    }
  }

  render(price, el_price);
};

if (productForms.length) {
  productForms.forEach((form) => {
    let productData = JSON.parse(form.querySelector(".product-data").innerHTML),
      el_formOptions = form.querySelector("product-form-options-container"),
      el_formSelectedOption = form.querySelector("product-form-selected"),
      el_variantId = form.querySelector(".js--product-form-id"),
      el_button = form.querySelector(".js--product-form-add"),
      el_price = form.querySelector("price");

    //console.log(productData);

    if (productData.available) {
      buildOptions(
        productData,
        el_formOptions,
        el_formSelectedOption,
        el_variantId,
        el_button,
        el_price,
      );
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
    });
  });
}

/* -------------------------------------------------------- SIZE CHARTS */
const sizeCharts = document.querySelectorAll(".js--close-size-chart");

if (sizeCharts.length) {
  sizeCharts.forEach((chart_close) => {
    let wrapper = chart_close.closest("size-chart-wrapper");

    chart_close.addEventListener("click", (e) => {
      e.preventDefault();

      wrapper.classList.remove("is--active");
    });
  });
}

/* -------------------------------------------------------- PRODUCT IMAGE SLIDER */

const productPage = document.querySelector("product-page");

if (productPage) {
  const getNavHeight = (nav) => {
    if (nav) {
      return nav.offsetHeight;
    } else {
      return 0;
    }
  };

  const slider_img = new Swiper(".js--product-image-slider", {
    modules: [Navigation, Autoplay],
    initialSlide: 0,
    loop: false,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 0,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  let mm = gsap.matchMedia();

  mm.add("(min-width: 1200px)", () => {
    let st = ScrollTrigger.create({
      trigger: "product-page",
      pin: "product-images-sticky",
      start: () => `top-=${getNavHeight(mainNav)} top`,
      end: "bottom bottom",
    });
  });

  window.addEventListener("DOMContentLoaded", () => {
    slider_img.autoplay.stop();
    slider_img.slideTo(0, 0);
    slider_img.autoplay.start();
  });
}

/* ======================================================================================= */
/* ========================================================================= WINDOW RESIZE */
/* ======================================================================================= */

let windowResize;

window.addEventListener("resize", () => {
  clearTimeout(windowResize);
  windowResize = setTimeout(() => {
    feature_forms_actions();
  }, 250);
});
